import React, { useState, useEffect } from 'react'
import axios from 'axios';
import { OutTable, ExcelRenderer } from "react-excel-renderer";

export default function DisplayCSV({
    url
}) {
    const [csvDataObject, setCsvDataObject] = useState({ cols: [], rows: [] })

    const loadCSVData = async () => { 
      const fetch = await axios.get(url)
      const parsedCsvData = [];
      const columnsCsv = [];
      let maxlength = 0
      fetch.data.split('\n').forEach((row, rowIndex) => {
      const rowData = row.split(',');
      parsedCsvData.push(rowData);
      if(rowData.length>maxlength){
        maxlength =rowData.length;
      }
      });
      for(let letter=0;letter<maxlength;letter++){
      columnsCsv.push({'name':String.fromCharCode(65+letter),'key':letter});
      }
      setCsvDataObject({
        cols:columnsCsv,
        rows:parsedCsvData
      });
  }
    useEffect(() => {
        loadCSVData()
        return () => {
            loadCSVData()
        };
    }, []);

    const styles = {
        div: {
            overflow: 'auto',
            position: "relative",
            height: '90%',
            border: '1px solid #ccc'
        }
    }
  return (
    <div style={{height: '60vh', overflowY: 'overlay'}}>
    {(Object.keys(csvDataObject).length>0) && (
    <OutTable
      data={csvDataObject.rows}
      columns={csvDataObject.cols}
      tableClassName="ExcelTable2007"
      tableHeaderRowClass="heading"
    />)
    }
</div>
  )
}